<template>
    <router-view />
</template>

<script setup>
import { useStoreApp } from "@/store/app";
import useInit from "@/composerable/useInit";

const appStore = useStoreApp();

useInit();
</script>

<style scoped></style>
